export default "__VITE_ASSET__JmXxonN5__"